import React, { useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { useQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";
import { GET_USER_DETAIL } from "redux/features/superAdminSlice/manageUsersSlice/manageUsersGql";
import { BottomButtons } from "shared/Components/bottomButtons";
import Loader from "shared/Components/loader";
import { HostProfile } from "./Components/HostProfile";
import { SubmitButton } from "./Components/SubmitButtons";
import { globalVariables } from "helper/globalVariables";
import { backIcon } from "helper/icons";

const EditAbleHostProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loader, setloader] = useState(false);
  const { loading, error, data } = useQuery(GET_USER_DETAIL, {
    variables: { authId: id },
  });
  const userData = data?.getUserDetail;
  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const showBtns = useMediaQuery({ query: "(max-width: 769px)" });

  const modalRef = useRef();
  const memberProfileRef = useRef();
  const [profileDataSave, setProfileDataSave] = useState({
    title: "",
    desc: "",
    type: "",
  });

  const handelSaveChanges = () => {
    memberProfileRef.current.saveChanges();
  };

  const handleCancel = () => {
    navigate("/admin/manage/users?page=refresh");
  };

  const onProfileSuccess = () => {
    setProfileDataSave({
      title: globalVariables.profileUpdated,
      desc: globalVariables.profileUpdatedSuccessDesc,
      type: "success",
    });
    modalRef.current.openModal();
  };

  const onProfileError = () => {
    setProfileDataSave({
      title: "pending",
      desc: "Something went wrong",
      type: "error",
    });
    modalRef.current.openModal();
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div  className="flex flex-col">
      <div className="flex justify-end">
        <SubmitButton
          handleCancel={() => navigate("/admin/manage/users")}
          handelSave={handelSaveChanges}
          isLoading={loader}
        />
      </div>
      <div className="flex justify-center align-middle hidden lg:flex">
        <HostProfile
          style={{ width: 280 }}
          ref={memberProfileRef}
          onProfileSuccess={onProfileSuccess}
          onProfileError={onProfileError}
          userProfileData={userData}
          setLoaderState={(e) => setloader(e)}
        />
      </div>
      {showBtns ? (
        <BottomButtons
          outlineLabel={"Cancel Changes"}
          fullLabel={"Save Changes"}
          onTapYes={handelSaveChanges}
          onTapNo={() => navigate("/admin/manage/users")}
          position={isMobile ? "fixed" : "sticky"}
          extraClass={isMobile ? "h-[80px]" : "dog-signup-bb-h"}
          btnCustomWidth="w-40 lg:w-44 max-[400px]:w-[140px] max-[280px]:w-[130px]"
        />
      ) : null}
      <PopUpMessages
        title={profileDataSave.title}
        desc={profileDataSave.desc}
        type={profileDataSave.type}
        ref={modalRef}
        onCloseModal={handleCancel}
      />
    </div>
  );
};

export default EditAbleHostProfile;
